import { getUtmParams } from '../tracking/helpers/utmParams';
import type { PageData } from '../tracking/pageData';

import type { Salesposter } from './spsApi';
import { getContentParams } from './getContentParams';

// replace underscore and whitespace with dash
const sanitizeValue = (str?: string) => str?.replaceAll(/[_\s]/gi, '-');

const cleanupObject = (data: Record<string, string | undefined>) => {
  Object.keys(data).forEach((key) => {
    if (data[key] === undefined) {
      delete data[key];
    }
  });

  return data;
};

const sanitizeValues = (data: Record<string, string | undefined>) => {
  return Object.keys(data).reduce<Record<string, string | undefined>>(
    (acc, key) => {
      acc[key] = sanitizeValue(data[key]);

      return acc;
    },
    {}
  );
};

export const getZuoraParams = ({
  salesposter,
  pageData,
  xDomainId,
}: {
  salesposter: Salesposter;
  pageData?: PageData;
  xDomainId?: string;
}) => {
  const { campaign } = salesposter;

  const { utm_source, utm_medium, utm_content, utm_campaign, utm_term } =
    getUtmParams();

  return cleanupObject(
    sanitizeValues({
      utm_source,
      utm_medium,
      utm_term,
      utm_content,
      utm_campaign: campaign || utm_campaign,
      x_domain_id: xDomainId,
      ...(pageData && getContentParams(pageData)),
    })
  );
};
